// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper-Too5VP","dropzone":"dropzone-i4kzZ5","icon":"icon-rQGIPI","control":"control-VOy0eG"};